import React from "react";
import styled from "styled-components";

const Container = styled.div`
  text-align: right;
  margin-bottom: 25px;
`;

const Title = styled.p`
  color: ${props => props.theme.textHighlight};
  margin: 0 0 10px 0;
  font-size: 14px;
  @media (min-width: 1800px) {
    font-size: 21px;
    line-height: 36px;
  }
  @media (max-width: 575px) {
    font-family: "dubai-medium";
  }
`;

const Label = styled.label`
  cursor: pointer;
  font-size: 12px;
  color: ${props => props.theme.text};
  padding-right: 10px;
  @media (min-width: 1800px) {
    font-size: 18px;
    line-height: 30px;
  }
  @media (max-width: 575px) {
    font-size: 14px;
  }
`;

const Option = styled.p`
  margin: 5px 0;
  display: flex;
  flex-direction: row-reverse;
`;

const Input = styled.input`
  :checked,
  :not(:checked) {
    position: absolute;
    left: -9999px;
  }
  :checked + label,
  :not(:checked) + label {
    position: relative;
    padding-right: 22px;

    @media (min-width: 1800px) {
      padding-right: 30px;
    }
  }
  :checked + label:before,
  :not(:checked) + label:before {
    content: "";
    position: absolute;
    right: 0;
    top: 2px;
    width: 10px;
    height: 10px;
    border: 1px solid ${props => props.theme.text};
    border-radius: 100%;
    background: none;
    @media (min-width: 1800px) {
      width: 12px;
      height: 12px;
      border: 2px solid ${props => props.theme.text};
      top: 8px;
    }
    @media (max-width: 575px) {
      width: 8px;
      height: 8px;
    }
  }
  :checked + label:after,
  :not(:checked) + label:after {
    content: "";
    width: 10px;
    height: 10px;
    background: ${props => props.theme.textHighlight};
    position: absolute;
    top: 3px;
    right: 1px;
    border-radius: 100%;
    -webkit-transition: all 0.2s ease;
    transition: all 0.2s ease;
    @media (min-width: 1800px) {
      width: 14px;
      height: 14px;
      top: 9px;
      right: 1px;
    }

    @media (max-width: 575px) {
      width: 8px;
      height: 8px;
    }
  }
  :not(:checked) + label:after {
    opacity: 0;
    -webkit-transform: scale(0);
    transform: scale(0);
  }
  :checked + label:after {
    opacity: 1;
    -webkit-transform: scale(1);
    transform: scale(1);
  }
`;

const RadioButton = ({ name, label, options }) => {
  return (
    <Container>
      <Title>{label}</Title>
      {options.map(item => (
        <Option key={item.id}>
          <Input type="radio" id={`${name}-${item.id}`} name={name} />
          <Label htmlFor={`${name}-${item.id}`}>{item.label}</Label>
        </Option>
      ))}
    </Container>
  );
};

export default RadioButton;
